var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.18012 0.184273C7.69625 -0.0737942 8.30377 -0.0737939 8.8199 0.184273L13.557 2.5528C13.6348 2.59171 13.7011 2.65026 13.7494 2.72266L15.0827 4.72266C15.1623 4.84199 15.1867 4.98973 15.1499 5.12835C15.1131 5.26696 15.0186 5.38309 14.8903 5.44722L13.8333 5.97569V10.176C13.8333 10.8704 13.441 11.5052 12.8199 11.8157L8.8199 13.8157C8.30377 14.0738 7.69625 14.0738 7.18012 13.8157L3.18012 11.8157C2.55902 11.5052 2.16668 10.8704 2.16668 10.176V5.97569L1.10974 5.44722C0.981464 5.38309 0.886906 5.26696 0.850096 5.12835C0.813286 4.98973 0.837768 4.84199 0.917321 4.72266L2.25065 2.72266C2.29892 2.65026 2.36525 2.59171 2.44307 2.5528L7.18012 0.184273ZM3.16668 6.47569V10.176C3.16668 10.4916 3.34501 10.7802 3.62733 10.9213L7.62733 12.9213C7.86194 13.0386 8.13808 13.0386 8.37269 12.9213L12.3727 10.9213C12.655 10.7802 12.8333 10.4916 12.8333 10.176V6.47569L9.55695 8.11389C9.33141 8.22666 9.05719 8.15384 8.91732 7.94403L8.00001 6.56807L7.0827 7.94403C6.94283 8.15384 6.66861 8.22666 6.44307 8.11389L3.16668 6.47569ZM8.00001 5.10766L12.2153 3.00001L8.37269 1.0787C8.13808 0.961397 7.86194 0.961397 7.62733 1.0787L3.78471 3.00001L8.00001 5.10766ZM2.83786 3.64462L2.06355 4.8061L6.49549 7.02207L7.26981 5.86059L2.83786 3.64462ZM13.1622 3.64462L8.73021 5.86059L9.50453 7.02207L13.9365 4.8061L13.1622 3.64462Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductLevel);
export default __webpack_public_path__ + "static/media/product-level.ed79ec78a02ebaa30fdf0f812153e3a3.svg";
export { ForwardRef as ReactComponent };